import Countdown from "react-countdown";
import { BoldHeading } from "./CoolHeading";
import { useHomeTeam } from "../hooks/useHomeTeam";

export function CountdownToCheeseburgerTime({ date }: { date: Date }) {
  const { slogans } = useHomeTeam();

  return (
    <div className="flex flex-col items-center gap-0 px-4 md:flex-row md:gap-4">
      <BoldHeading>{slogans.prematch}</BoldHeading>
      <div className="flex flex-col gap-2 lg:gap-1 lg:pb-2">
        <p
          className={`-mb-6 font-spacemono text-[3rem] font-black uppercase text-primary lg:text-[3.5rem] dark:bg-inherit dark:text-white`}
        >
          Soon
        </p>
        <Countdown
          date={date}
          intervalDelay={0}
          precision={3}
          renderer={(props) => (
            <span
              className={`font-spacemono text-[1rem] text-primary dark:text-white`}
            >
              {[props.hours + props.days * 24, props.minutes, props.seconds]
                .map((num) => num.toString().padStart(2, "0"))
                .concat(props.milliseconds.toString().padStart(3, "0"))
                .join(":")}
            </span>
          )}
        />
      </div>
    </div>
  );
}
